export default "__VITE_ASSET__40cc464c__"